import * as React from "react";
import { Alert, AlertTitle, Box, Button } from "@mui/material";
import DashboardLayout from "../components/DashboardLayout";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

export default function SunsureErrorFallback() {
  return (
    <DashboardLayout>
      <Box sx={{ width: "100%", maxWidth: 720, margin: "24px auto 0" }}>
        <Alert
          severity="error"
          role="alert"
          action={
            <Button
              variant="outlined"
              color="inherit"
              size="small"
              startIcon={<RestartAltIcon />}
              onClick={() => window.location.reload()}
              sx={{ whiteSpace: "nowrap", bgcolor: "transparent" }}
            >
              Reload application
            </Button>
          }
        >
          <AlertTitle>Something went wrong</AlertTitle>
          An error has occurred in the application. Please contact an
          administrator or supervisor if these errors persist.
        </Alert>
      </Box>
    </DashboardLayout>
  );
}
